export default __webpack_public_path__ + "static/media/alcades.03bc7eaa.png";